import { NgModule } from '@angular/core';
import { MainComponent } from './main.component';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../auth/_guards/auth.guard';
import { PdfScraperModule } from './admin/pdf-scraper/pdf-scraper.module';
import { PortalGuard } from '../auth/_guards/portal.guard';
// TODO: Code Review - Please rename to PortalAuthGuard
const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    canActivate: [PortalGuard],
    children: [
      {
        path: 'batch-send-text',
        loadChildren: './batchSendText/batchSendText.module#BatchSendTextModule'
      },
      {
        path: 'bank',
        loadChildren: './bank/landing.module#BankModule'
      },
      {
        path: 'tickets',
        loadChildren: './tickets/tickets.module#TicketsModule'
      },
      {
        path: 'dashboard',
        loadChildren: './dashboard/dashboard.module#DashboardModule'
      },
      {
        path: 'search-customer',
        loadChildren: './customer/customer-search/customer-search.module#CustomerSearchModule'
      },
      {
        path: 'customer/:customerTaskId',
        loadChildren: './customer/customer-card.module#CustomerCardModule'
      },
      {
        path: 'account/:accountTaskId',
        loadChildren: './account/account-card.module#AccountCardModule'
      },
      {
        path: 'comparator',
        loadChildren: './admin/comparator/pdf-parser.module#PdfParserModule'
      },
      {
        path: 'comparator/:state',
        loadChildren: './admin/comparator/pdf-parser.module#PdfParserModule'
      },
      {
        path: 'pdf-parser/templates',
        loadChildren: './admin/comparator/pdf-templates/pdf-template.module#PdfTemplateModule'
      },
      {
        path: 'pdf-parser/test',
        loadChildren: './admin/comparator/test/parser.module#ParserModule'
      },
      {
        path: 'pdf-parser/compare',
        loadChildren: './admin/comparator/recommender/recommender.module#RecommenderModule'
      },
      {
        path: 'pdf-parser/results',
        loadChildren: './admin/comparator/results/result.module#ResultModule'
      },
      {
        path: 'plans',
        loadChildren: './admin/comparator/plans/plan.module#PlanModule'
      },
      {
        path: 'plans/create/:plan_type',
        loadChildren: './admin/comparator/plans/plan.module#PlanModule'
      },
      {
        path: 'plans/compare/:plan_type',
        loadChildren: './admin/comparator/plans/plan.module#PlanModule'
      },
      {
        path: 'plans/:plan_type/:plan_id',
        loadChildren: './admin/comparator/plans/plan.module#PlanModule'
      },
      {
        path: 'bots/live-chat',
        loadChildren: './bots/live-chat/live-chat.module#LiveChatModule'
      },
      {
        path: 'pdf-scraper/dashboard',
        loadChildren: './admin/pdf-scraper/pdf-scraper.module#PdfScraperModule'
      },
      {
        path: 'pdf-scraper/dashboard/:state',
        loadChildren: './admin/pdf-scraper/pdf-scraper.module#PdfScraperModule'
      },
      {
        path: 'pdf-scraper/schema-builder',
        loadChildren: './admin/pdf-scraper/schema-builder/schema-builder.module#SchemaBuilderModule'
      },
      {
        path: 'pdf-scraper/test',
        loadChildren: './admin/pdf-scraper/test/scraper.module#ScraperModule'
      },
      {
        path: 'pdf-scraper/scraping-templates',
        loadChildren:
          './admin/pdf-scraper/templates/scraping-templates.module#ScrapingTemplatesModule'
      },
      {
        path: 'pdf-scraper/edit-pdf-template/:id',
        loadChildren: './admin/pdf-scraper/edit-template/edit-pdf-schema.module#EditPdfSchemaModule'
      },
      {
        path: 'pdf-scraper/results',
        loadChildren: './admin/pdf-scraper/results/result.module#ScrapingResultModule'
      },
      {
        path: 'reports',
        loadChildren: './reports/report.module#ReportModule'
      },
      {
        path: 'profile',
        loadChildren: './profile/profile.module#ProfileModule'
      },
      {
        path: 'electricity',
        loadChildren: './electricity/electricity.module#ElectricityModule'
      },
      {
        path: 'boards',
        loadChildren: './boards/boards.module#BoardsModule'
      },
      {
        path: 'boards/:id',
        loadChildren: './boards/boards.module#BoardsModule'
      },
      {
        path: 'adminBoards',
        loadChildren: './admin-boards/admin-boards.module#AdminBoardsModule'
      },
      {
        path: 'adminBoards/:id',
        loadChildren: './admin-boards/admin-boards.module#AdminBoardsModule'
      },
      {
        path: 'notifications',
        loadChildren: './notifications/notifications.module#NotificationsModule'
      },
      {
        path: 'action-needed',
        loadChildren: './actionNeeded/actionNeeded.module#ActionNeededModule'
      },
      {
        path: 'chat',
        loadChildren: './chat/chat.module#ChatModule'
      },
      {
        path: 'search',
        loadChildren: './search/search.module#SearchModule'
      },
      {
        path: 'dashboardv2',
        loadChildren: './dashboardV2/dashboardV2.module#DashboardV2Module'
      },
      {
        path: 'dashboard',
        loadChildren: './dashboard/dashboard.module#DashboardModule'
      },
      {
        path: 'billpay',
        loadChildren: './billpay/billpay.module#BillPayModule'
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: '*',
        redirectTo: 'dashboard'
      },
      {
        path: '**',
        redirectTo: 'portal'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/portalV2/main-routing.module.ts